module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc",
      "title": "Contents"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword"
    }
  }, [_vm._v("Foreword by John Witte Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter1"
    }
  }, [_vm._v("1: The Biblical Foundations of Law")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Creation, Fall and the Patriarchs")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Randy Beck and David VanDrunen")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2: Law and Political Order")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Israel’s Constitutional History")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("William S. Brewbaker III and V. Philips Long")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Criminal and Civil Law in the Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("The Mosaic Law in Christian Perspective")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("David Skeel and Tremper Longman III")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: The Law of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Law in the Wisdom Literature")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Roger P. Alford and Leslie M. Alford")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: Crying Out for Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Civil Law and the Prophets")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Barbara E. Armacost and Peter Enns")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: The Kingdom of God, Law, and the Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Jesus and the Civil Law")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Robert F. Cochran Jr. and Dallas Willard")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Civil Law and Civil Disobedience")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("The Early Church and the Law")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Joel A. Nichols and James W. McCarty III")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Living as Christians Under Civil Law")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("The New Testament Letters, Law, and Politics")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("David M. Smolin and Kar Yong Lim")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Expectation and Consummation")])]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_vm._v("Law in Eschatological Perspective")]), _vm._v(" "), _c('p', {
    staticClass: "verse2"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("John Copeland Nagle and Keith A. Mathison")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ListofContributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/GeneralIndex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ScriptureIndex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0